import React from "react";
import { version, clientName } from "../../config/config";

import Logo from "../../assets/images/nucleus-icon-white.svg";

const SideBarFooter = props => {
  return (
    <div className="mt-auto sidebar-footer">
      <div className="logo-container">
        <img src={Logo} alt="Profile" />
        <span className="version">{version.toFixed(2)}</span>
      </div>
      <div className="built-for">{clientName}</div>
    </div>
  );
};

export default SideBarFooter;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Footer.jsx